module.exports = __webpack_public_path__ + "img/ncc-logo.8c10f0d4.jpg";